var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"content"},[_c('link-model',{attrs:{"to":"/lhUI"}},[_vm._v("lhUI")]),_c('link-model',{attrs:{"to":"https://www.bilibili.com/"}},[_vm._v("bilibili")]),_c('link-model',{attrs:{"to":"https://browser.lenovo.com.cn/ai/?f=steer"}},[_vm._v("AI导航")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }